const RelationshipTypeFrom = [
  { value: 1, name: 'Controlling Person Of', description: 'Controlling Person Of' }
];

export default RelationshipTypeFrom;
